"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _focusRingWithColor = _interopRequireDefault(require("../../utils/focusRingWithColor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconWrapper = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "IconWrapper",
  componentId: "z9032r-0"
})(["margin-right:", ";cursor:pointer;width:", ";height:", ";flex-direction:column;justify-content:center;border-radius:", ";border:1px solid transparent;&,&:hover{color:", ";}&:focus{", ";border:1px solid ", ";outline:none;"], (0, _rem.default)(_spacing.default.base * 0.2), (0, _rem.default)(_spacing.default.base * 1.8), (0, _rem.default)(_spacing.default.base * 3), (0, _rem.default)(_spacing.default.base * 0.2), function (_ref) {
  var disabled = _ref.disabled;
  return (0, _toColorString.default)(disabled ? _color.default.opacity.charcoal40 : _color.default.interaction.pacificOcean);
}, (0, _focusRingWithColor.default)(_color.default.interaction.pacificOcean40), (0, _toColorString.default)(_color.default.interaction.pacificOcean));
var _default = IconWrapper;
exports.default = _default;